/**
 * Created by admin on 2017/3/23.
 */
import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();

/*��Ʒ�б�*/
export const GetProductByPage = params => { return axios.get(`${base}/api/Product/GetProductByPage`,{ params: params }); };
/*��ȡ������Ʒ*/
export const GetProductById = params => { return axios.get(`${base}/api/Product/GetProductById`,{ params: params }); };
/*������Ʒ��Ϣ*/
export const ProductUpdate = params => { return axios.post(`${base}/api/Product/ERP_ProductUpdate`,params,config); };
/*�����Ʒ*/
export const ProductAdd = params => { return axios.post(`${base}/api/Product/ERP_ProductAdd`,params,config); };
/*������ѯ*/
export const GetProductExport = params => { return axios.get(`${base}/api/Product/GetProductExport`,{ params: params }); };
/*ɾ����Ʒ*/
export const ProductDel = params => { return axios.post(`${base}/api/Product/ERP_ProductDel`,params,config); };
/*������Ʒ*/
export const ProductUnEnable = params => { return axios.post(`${base}/api/Product/ERP_ProductUnEnable`,params,config); };

export const ProductUpdate2 = params => { return axios.post(`${base}/api/Product/ProductUpdate`,params,config); };
export const ProductAdd2 = params => { return axios.post(`${base}/api/Product/ProductAdd`,params,config); };
export const GetProductByPageEx = params => { return axios.get(`${base}/api/Product/GetProductByPageEx`,{ params: params }); };



// WEBPACK FOOTER //
// ./src/api/productApi.js